module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Augusto Jacinto Mussindo Alberto.f2f1de7e.jpg";